import React, {ReactElement, useState, useCallback, useEffect} from 'react';
// import { strings } from 'src/localization';
// import { DateTime } from '@reynolds/datetime';
import css from '../../ServiceDocs.module.scss';
import { IconVideo, IconSelectCircle } from 'src/content/icons';

type iconNavItem = {
    type: string;
    iconFilled: boolean;
    onClick: (index: number) => void;
}

export interface IProps {
    iconNav: iconNavItem[];
    currentImg: number;
    sortedOrder: number[];
}

const ServiceDocsMediaNav = (props: IProps) => {
    const [sectionTracker, setSectionTracker] = useState(1);
    const iconList: ReactElement[] = [];
    const iconBreakdown: ReactElement[][] = [];
    let displayList: ReactElement[] = [];
    const sectionMax = 8;
    let showRightEll = false;
    let showLeftEll = false;

    // Find how many sections there are. 8 items per set. Ellipses will encapsulate further items.
    // Selecting and ellipses will display the next set and auto select the neighboring item from the directional set
    let sectionCount = Math.ceil(props.iconNav.length / sectionMax);
    if (sectionCount === 0) {
        sectionCount = 1;
    }
    if (sectionTracker < sectionCount) {
        showRightEll = true;
    }
    if (sectionTracker > 1) {
        showLeftEll = true;
    }

    // right ellipsis click
    const clickRightEllipsis = useCallback(() => {
        const next = sectionTracker + 1;
        setSectionTracker(next);
        props.iconNav[(8*(next-1))].onClick((8*(next-1)));
    }, [sectionTracker, props.iconNav]);

    // left ellipsis click
    const clickLeftEllipsis = useCallback(() => {
        const prev = sectionTracker - 1;
        setSectionTracker(prev);
        props.iconNav[(8*prev) - 1].onClick((8*prev) - 1);
    }, [sectionTracker, props.iconNav]);

    useEffect(() => {
        const sortedLocation = props.sortedOrder.findIndex(result => result === props.currentImg) + 1;
        const whatSection = Math.ceil(sortedLocation / sectionMax);
        setSectionTracker(whatSection);
    }, [props.currentImg, props.sortedOrder]);

    let navIconClass = css.navIconClass;

    // Create entire array of items. We will break this down to a smaller arrays for display.
    props.iconNav.forEach((x, index) => {
        if (x.iconFilled) {
            navIconClass = css.navIconFillClass;
        } else {
            navIconClass = css.navIconClass;
        }
        let icon = <div className={navIconClass} onClick={() => x.onClick(index)} key={'navIcon'+index}>
            <IconSelectCircle/>
        </div>;
        if (x.type === 'V') {
            if (x.iconFilled) {
                navIconClass = css.navIconVidFillClass;
            } else {
                navIconClass = css.navIconVidClass;
            }
            icon = <div className={navIconClass} onClick={() => x.onClick(index)} key={'navIcon'+index}>
                <IconVideo/>
            </div>;
        }
        iconList.push(icon);
    });

    // prep display
    let prepTrack = 1;
    let prepSection = 1;
    // const test: number[][] = [];
    for (let x = 1; x<=sectionCount+1; x++) {
        iconBreakdown[x] = [];
    }
    // console.log(test);
    iconList.forEach((x) => {
        iconBreakdown[prepSection][prepTrack] = (x);
        // test[prepSection][prepTrack] = 0;
        // console.log(prepSection + ' ' + prepTrack);
        if (prepTrack >= sectionMax) {
            prepSection+=1;
            prepTrack = 0;
        }
        prepTrack++;
    });

    displayList = (iconBreakdown[sectionTracker]);

    return (
        <div className={css.navIconArea}>
            {showLeftEll ? <div className={css.leftEllipsis}>
                <span onClick={clickLeftEllipsis}>...</span>
            </div>: null}
            {displayList}
            {showRightEll ? <div className={css.rightEllipsis}>
                <span onClick={clickRightEllipsis}>...</span>
            </div>:null}
        </div>
    );
};

export default ServiceDocsMediaNav;